import { TableRow, TableCell, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function GradeListItem({ item, markingPeriods, getGradeForMP, gradeLetters }) {
  const { t } = useTranslation();

  return (
    <TableRow hover>
      <TableCell>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: '500' }}>
            {item.category}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {item.description}
          </Typography>
        </Box>
      </TableCell>

      {Array.isArray(markingPeriods) && markingPeriods.length > 0 ? (
        markingPeriods.map((mp) => {

          const gradeVal = getGradeForMP(item.learningObjectiveGrades, mp.id);

          let displayGrade = t('N/A');

          if (gradeVal !== '' && gradeVal !== null && gradeVal !== undefined) {
            const match = Array.isArray(gradeLetters) 
              ? gradeLetters.find(gl => String(gl.maxGrade) === String(gradeVal)) 
              : null;
              
            displayGrade = match ? match.letterGrade : gradeVal;
          }

          return (
            <TableCell key={mp.id} align="center">
              {displayGrade}
            </TableCell>
          );
        })
      ) : (
        <TableCell align="center" colSpan={4}>{t('N/A')}</TableCell>
      )}
    </TableRow>
  );
}